declare global {
  interface Navigator {
    msSaveBlob?: (blob: any, defaultName?: string) => boolean;
    msSaveOrOpenBlob?: (blob: any, defaultName?: string) => boolean;
  }
}

const downloadUrlEvergreen = (download: boolean) => (url: string, filename?: string) => {
  filename ||= "unknown";

  const downloadLink = document.createElement("a");
  downloadLink.href = url;
  if (download) {
    downloadLink.download = filename;
  }
  downloadLink.click();
};

export const downloadUrl = downloadUrlEvergreen(true);

export const downloadOrOpenUrl = downloadUrlEvergreen(false);
